import hdrm from '../../hdrm';
import view from '../../view';
import constants from '../constants';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const getGlobalFromChild = (childElementId, { strategy } = {}) => {
  if (strategy === UPDATE_LIVE_ONLY) {
    const parentLiveElement = view.accessors.getParentLiveElement(childElementId);
    const globalElement = parentLiveElement.closest(constants.GLOBAL_TAG_NAME);

    return globalElement ? view.accessors.getLiveElementId(globalElement) : null;
  }

  const { parentElement } = view.accessors.getStaticElement(childElementId);
  const globalElement = parentElement.closest(constants.GLOBAL_TAG_NAME);

  return globalElement ? hdrm.accessors.getReferenceIdByStaticElement(globalElement) : null;
};

export default getGlobalFromChild;
